import { gql } from "@apollo/client";

export const InaTypesQuery = gql`
  query FetchInaTypes {
    inaTypes {
      id
      typeCode
      friendlyName
      assignedToRoleNormally {
        id
        name
      }
      assignedToRoleForNonAssuranceReviews {
        id
        name
      }
      assignedToRoleForPprpProgramReviews {
        id
        name
      }
      reassignableToRoles {
        id
        name
      }
    }
  }
`;
